<template>
  <slot></slot>

    <modal :id="modalId" @shown="init">

      <template v-slot:header>
        <h4 class="modal-title">Clone Smartlist</h4>
      </template>

        <form id="clone-smartlist" method="POST" :action="action">
          <input type="hidden" name="_token" :value="$csrf_token">

          <div class="text-center">
            <strong><i class="fa fa-fw fa-check-square"></i> Smartlist structure</strong><br>
            <span class="text-muted">A configuration of native and custom fields will be copied.</span>
          </div>

          <div class="row mb-0 mt-4">
            <div class="alert alert-secondary col-md-6 offset-md-3 mb-0">

              <!-- Adjusters -->
              <div>
                <label class="checkbox-inline">
                  <input type="checkbox" name="adjusters" v-model="adjusters"> Adjusters
                </label>
                <div>
                  <span class="text-muted">
                    <template v-if="adjusters">
                      The complete list of adjusters (smartlist records) will be included.
                    </template>
                    <template v-else>
                      No adjusters (smartlist records) will be included.
                    </template>
                  </span>
                </div>
              </div>

              <!-- Include custom data -->
              <div v-if="adjusters" class="mt-4">
                <label class="checkbox-inline">
                  <input type="checkbox" name="custom" v-model="custom"> Include custom data
                </label>
                <div>
                  <span class="text-muted">
                    <template v-if="custom">
                      If the smartlist contains custom fields, the data from those fields will be included.
                    </template>
                    <template v-else>
                      No custom field data will be included.
                    </template>
                  </span>
                </div>
              </div>

              <!-- Include notes -->
              <div v-if="adjusters" class="mt-4">
                <label class="checkbox-inline">
                  <input type="checkbox" name="notes" v-model="notes"> Include notes
                </label>
                <div>
                  <span class="text-muted">
                    <template v-if="notes">
                      The most recent notes for each record will be included.
                    </template>
                    <template v-else>
                      No notes will be included.
                    </template>
                  </span>
                </div>
              </div>

            </div>
          </div>

          <div class="row mb-0 mt-4">
            <div class="col-md-6 offset-md-3 text-center p-0 mb-0">
              <input v-model="name" name="name" type="text" class="form-control" placeholder="Enter a new smartlist name...">
            </div>
          </div>

        </form>

      <template v-slot:footer>
        <button type="button" class="btn btn-white" @click="hideModal"><i class="fa fa-fw fa-ban"></i> Close</button>
        <button type="submit" form="clone-smartlist" class="btn btn-primary" :disabled="name.length === 0"><i class="fa fa-fw fa-copy"></i> Clone</button>
      </template>

    </modal>
</template>

<script>
  import HasModal from "../mixins/HasModal";

  export default {
    mixins: [HasModal],

    props: {
      action: {type: String, required: true},
      modalId: {type: String, default: 'smartlistCloneModal'},
    },

    /**
     * Variables (models).
     */
    data () {
      return {
        adjusters: false,
        custom: false,
        notes: false,
        name: '',
      }
    },

    /**
     * Computed values
     */
    computed: {
    },

    /**
     * Functions (methods).
     */
    methods: {

      init() {
        this.adjusters = false;
        this.custom = false;
        this.notes = false;
        this.name = '';
      },

    },
  }
</script>
